import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { CheckInfo, Roster } from './checkin.model';

@Injectable({ providedIn: 'root' })
export class AddCheckinService {
  apiHost: string = environment.apiHost;
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  AddCheckIn(
    eventId: number,
    members: number[],
    userId: string,
    createdBy: string
  ): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/Checkin/AddCheckIn', {
          EventId: parseInt(eventId.toString()),
          Members: members,
          UserId: userId,
          CreatedBy: createdBy,
        })
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: AddCheckIn', msg);
            resolve(null);
          }
        );
    });
    return promise;
  }

    AddCheckInByService(
    serviceId: number,
    members: number[],
    userId: string,
    createdBy: string
  ): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/Checkin/AddCheckInByService', {
          EventId: parseInt(serviceId.toString()),
          Members: members,
          UserId: userId,
          CreatedBy: createdBy,
        })
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: AddCheckIn', msg);
            resolve(null);
          }
        );
    });
    return promise;
  }

    AddCheckInByGroup(
    groupId: number,
    members: number[],
    userId: string,
    createdBy: string
  ): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/Checkin/AddCheckInByGroup', {
          EventId: parseInt(groupId.toString()),
          Members: members,
          UserId: userId,
          CreatedBy: createdBy,
        })
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: AddCheckIn', msg);
            resolve(null);
          }
        );
    });
    return promise;
  }  

    AddCheckInByVenue(
    venueId: number,
    members: number[],
    userId: string,
    createdBy: string
  ): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/Checkin/AddCheckInByVenue', {
          EventId: parseInt(venueId.toString()),
          Members: members,
          UserId: userId,
          CreatedBy: createdBy,
        })
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: AddCheckIn', msg);
            resolve(null);
          }
        );
    });
    return promise;
  }  

  GetCheckInfo(eventId: number, userId: string): Promise<CheckInfo> {
    let promise = new Promise<CheckInfo>((resolve, reject) => {
      return this.http
        .get<CheckInfo>(
          this.apiHost +
            '/Checkin/GetCheckInfo?EventId=' +
            eventId.toString() +
            '&UserId=' +
            userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: AddCheckIn', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  GetRoster(eventId: number): Promise<Roster[]> {
    let promise = new Promise<Roster[]>((resolve, reject) => {
      return this.http
        .get<Roster[]>(
          this.apiHost + '/Checkin/GetRoster?EventId=' + eventId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: Get Roster', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }

  CheckIn(
    eventId: number,
    memberId: number,
    createdBy: string,
    status: boolean
  ): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(
          this.apiHost +
            '/Checkin/CheckIn?EventId=' +
            eventId.toString() +
            '&MemberId=' +
            memberId.toString() +
            '&CreatedBy=' +
            createdBy +
            '&Status=' +
            status,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['statusMessage']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Add Checkin: CheckIn', msg);
            reject('Please check your connection!');
          }
        );
    });
    return promise;
  }
}
